// extracted by mini-css-extract-plugin
export default {"cls1":"YBBlcTwiPWxy9iYJFaQx","cls2":"m3HcRrjFqpVa90qOgpqM YBBlcTwiPWxy9iYJFaQx","bookingAppRedesign":"QziY9dYRGh9UmN0wfFLE"};